<template>
  <fragment>
    <slot :keyId="modalOpensCounter" :keyUpdater="onModalShow" />
  </fragment>
</template>

<script>
import OpensCounterMixin from '@/mixins/OpensCounterMixin';

export default {
  name: 'ForceUpdateBehaviour',
  mixins: [OpensCounterMixin],
};
</script>

<style scoped></style>
